import { render, staticRenderFns } from "./DoubleConfirmation.vue?vue&type=template&id=3056580f&"
import script from "./DoubleConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DoubleConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports